/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { getSelectedEvent, getImageVersion } from '../common'

const initialState: {
  currentEventId: string // current selected event in the event selector on the feed
  pinnedPostsCount: number
  imageVersion: number
} = {
  currentEventId: getSelectedEvent() ?? '',
  pinnedPostsCount: 0,
  imageVersion: getImageVersion(),
}

const siteSlice = createSlice({
  name: 'site_slice',
  initialState,
  reducers: {
    setCurrentEventId: (state, action: PayloadAction<string>) => {
      state.currentEventId = action.payload
    },
    setPinnedPostsCount: (state, action: PayloadAction<number>) => {
      state.pinnedPostsCount = action.payload
    },
    updateImageVersion: state => {
      const newVersion = Date.now()
      state.imageVersion = newVersion
      sessionStorage.setItem('imageVersion', newVersion.toString())
    },
  },
})

export const {
  // global utilities for the whole app
  setCurrentEventId,
  setPinnedPostsCount,
  updateImageVersion,
} = siteSlice.actions
export default siteSlice.reducer
